<template
  ><!--0元试用 -->
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <!-- <div class="headReturn">
      <span @click="clickLocalStep"> <i class="el-icon-arrow-left"></i> 返回列表</span>
      <span style="margin: 0 20px">|</span>
      <span class="name">0元试用</span>
    </div> -->
    <div class="backBox">
      <img
        class="pointer"
        @click="clickLocalStep()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">0元试用</span>
    </div>
    <!--  活动条件表单部分 -->
    <div v-loading="fromLoading" class="secondstep">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        class="backgroundForm"
        label-width="160px"
        :rules="rules"
      >
        <div class="newsInfo" style="margin-top:0px;">基本信息</div>
        <el-form-item label="活动名称:" required>
          <el-input
            v-model="ruleForm.activityName"
            maxlength="50"
            show-word-limit
            placeholder="请填入活动名称"
            style="width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动时间:" required>
          <div class="my_select_time">
            <!-- <el-date-picker
              v-model="activityTimeValue"
              type="datetimerange"
              class="rangeTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              ref="timeBox"
              @change="activityTimeChange"
              style="width: 400px; font-size: 12px"
              :picker-options="pickerOptionsValue"
              :default-time="defaultTime"
            >
            </el-date-picker> -->
            <el-date-picker
              v-model="activityTimeValue[0]"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              :picker-options="pickerOptionsValue1"
              :default-time="defaultTime[0]"
              @change="activityTimeChange"
              :disabled="isStartEdit"
              placeholder="选择日期时间"
            >
            <!-- :disabled="$route.query.valueRow && !isSave || isStartEdit" -->
            </el-date-picker>
            <span style="margin: 0 10px;">-</span>
            <el-date-picker
              v-model="activityTimeValue[1]"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptionsValue2"
              @change="activityTimeChange"
              :default-time="defaultTime[1]"
              placeholder="选择日期时间"
            >
            </el-date-picker>
            <!-- <i class="el-icon-circle-close date_icon1" @click="activityTimeValue = []"></i> -->
            <img
              src="@/assets/images/select_date.svg"
              alt=""
              class="date_icon2"
            />
          </div>
          <span class="lastTime" style="color: #666">
            活动持续 <span style="color: #2670FB">{{ timeDay }}</span> 天
            <span style="color: #2670FB">{{ timeOut }}</span> 小时
            <el-tooltip
              class="item"
              effect="light"
              content="活动有效期不可超过订购有效期"
              placement="bottom"
            >
              <el-button type="text" style="width: 35px;">
                <i class="el-icon-question"></i>
              </el-button>
            </el-tooltip>
          </span>
        </el-form-item>
        <el-form-item label="活动对象:" required>
          <el-radio-group v-model="ruleForm.activityObject" @change="handleActivityObj" :disabled="isStartEdit">
            <el-radio :label="0">不限</el-radio>
            <el-radio :label="1">指定身份</el-radio>
            <el-radio :label="2" disabled>指定人群</el-radio>
          </el-radio-group>
          <span class="margin-left-12">
            <el-popover
              placement="right-start"
              trigger="hover"
              content="您不满足使用该功能的条件，请联系专属客服了解~">
              <el-button slot="reference" disabled>{{ selectCrowdText }}</el-button>
            </el-popover>
          </span>
        </el-form-item>
        <el-form-item
          label="新老客户:"
          required
          v-if="ruleForm.activityObject === 1"
        >
          <el-radio-group v-model="ruleForm.newOldCustomer" :disabled="isStartEdit">
            <el-radio :label="0">不限</el-radio>
            <el-radio :label="1">新客</el-radio>
            <el-radio :label="2">老客</el-radio>
          </el-radio-group>
          <span class="margin-left-12">
            <span class="tips-style margin-left-12">新老客说明</span>
            <el-tooltip class="item" effect="light" placement="bottom">
              <span slot="content">
                <div>历史订单中已完成订单的订单数为0则定义为新客</div>
                <div>历史订单中已完成订单的订单数≥1则定义为老客</div>
              </span>
              <i class="el-icon-question margin-left-8"></i>
            </el-tooltip>
          </span>
        </el-form-item>
        <el-form-item label="参与对象:" prop="partner" required v-if="ruleForm.activityObject == '1'">
          <el-checkbox-group
            v-model="ruleForm.partner"
            @change="checkListchange"
            :disabled="isStartEdit"
          >
            <el-checkbox label="-1" name="partner">全部</el-checkbox>
            <el-checkbox
              label="0"
              name="partner"
              :disabled="ruleForm.partner == -1"
              >非会员</el-checkbox
            >
            <el-checkbox
              v-for="(item, index) in levelList"
              :key="index"
              :label="index + 1 + ''"
              name="partner"
              :disabled="ruleForm.partner == -1"
              >{{ item }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
            label="入会时间:"
            v-if="ruleForm.activityObject == '1' && ruleForm.partner != 0"
          >
          <el-date-picker
            v-model="ruleForm.membershipTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            type="datetime"
            :disabled="isEditOrDraft"
            placeholder="选择日期时间">
          </el-date-picker>
          之后成为会员的用户可参与活动
          </el-form-item>
        <el-form-item label="活动条件:">
          <el-checkbox
            label="关注店铺后方可参与活动"
            v-model="ruleForm.condFollow"
            :true-label="1"
            :false-label="0"
            :disabled="isStartEdit"
          ></el-checkbox>
          <!-- <el-checkbox
            label="入会后方可参与"
            v-model="ruleForm.ruleDTO.isOpenCard"
            :true-label="1"
            :false-label="0"
            :disabled="isStartEdit"
          ></el-checkbox> -->
          <!-- <span
            v-show="ruleForm.ruleDTO.isOpenCard == 1"
            style="color:#f01111;margin-left: 20px;"
            >为保证用户体验，请尽量确保用户入会后，能满足“活动对象”会员等级设置</span
          > -->
        </el-form-item>
        <div class="newsInfo">试用设置</div>
        <el-form-item label="试用产品:" required>
          <el-radio-group
            v-model="ruleForm.ruleDTO.trialType"
            :disabled="$route.query.valueRow && !isSave || isStartEdit"
          >
            <el-radio :label="1">自定义</el-radio>
            <el-radio :label="2">选择商品</el-radio>
          </el-radio-group>
          <el-button
            style="margin-left:30px;"
            @click="dialogFormVisible = true"
            :disabled="$route.query.valueRow && !isSave || isStartEdit"
            class="btn1"
            v-if="ruleForm.ruleDTO.trialType == 2"
            >选择商品</el-button
          >

          <el-upload
            action="https://jsonplaceholder.typicode.com/posts/"
            list-type="picture-card"
            style="width:120px;height:120px;margin-bottom:10px;"
            :before-upload="beforeAvatarUpload"
            ref="upload"
            v-if="ruleForm.ruleDTO.trialType == 1"
            :disabled="$route.query.valueRow && !isSave"
          >
            <img
              v-if="imageUpload"
              style="width:120px;height:120px;margin-bottom:10px;"
              :src="imageUpload"
              class="avatar"
            />
            <i
              class="el-icon-plus"
              v-show="!imageUpload"
              style="transform: translateY(-10px);"
            ></i>
            <div
              style="position: absolute;top:0;left:135px;color:#999999;text-align:left;"
            >
              <div style="height:20px;">建议上传尺寸：190px*190px</div>
              <div style="height:20px;">图片大小2M以内</div>
              <div style="height:20px;">格式：jpg、png</div>
            </div>
          </el-upload>
          <div
            style="width:120px;height:120px;margin-bottom:10px;border: 1px dashed #c0ccda;border-radius: 6px;"
            v-else
          >
            <img
              v-if="imageUpload2"
              style="width:120px;height:120px;margin-bottom:10px;"
              :src="imageUpload2"
              class="avatar"
            />
          </div>
          <div class="ylt">
            <!-- <div class="yltText1">专属0元试用</div> -->
            <div class="yltText1">{{ ruleForm.activityName }}</div>
            <div class="yltText2">{{ ruleForm.ruleDTO.productName }}</div>
            <img
              :src="
                ruleForm.ruleDTO.trialType == 1 ? imageUpload : imageUpload2
              "
              alt=""
            />
            <div class="smart_right_tip">
              图为预览效果，以实际投放位置效果为准
            </div>
          </div>
        </el-form-item>
        <el-form-item label="产品名称:" required label-width="160px">
          <el-input
            v-model="ruleForm.ruleDTO.productName"
            maxlength="12"
            show-word-limit
            placeholder="请填入"
            style="width: 200px"
            :disabled="$route.query.valueRow && !isSave || isStartEdit"
          ></el-input>
        </el-form-item>
        <el-form-item label="试用份数:" required label-width="160px">
          <el-input
            v-model="ruleForm.ruleDTO.trialNum"
            show-word-limit
            placeholder="请填入"
            style="width: 100px"
            type="number"
            @blur="beAdd()"
            :disabled="$route.query.valueRow && !isSave"
          ></el-input>
          <el-tooltip
            class="item"
            effect="light"
            content="如预约用户大于试用份数，则系统随机分配给用户"
            placement="bottom"
          >
            <el-button type="text" style="width: 35px;">
              <i class="el-icon-question" style="color: #ccc;"></i>
            </el-button>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="试用领取规则:" required>
          <el-radio-group v-model="ruleForm.ruleDTO.trialRule" :disabled="isStartEdit">
            <el-radio :label="1">预约时填写地址</el-radio>
            <el-radio :label="2">中奖后填写地址</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开奖时间:" required>
          <el-date-picker
            v-model="ruleForm.ruleDTO.prizeTime"
            type="datetime"
            placeholder="选择日期时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :disabled="isStartEdit"
          ></el-date-picker>
          <el-tooltip
            class="item"
            effect="light"
            content="如需中奖后填写地址，建议预留足够的时间给用户填写地址"
            placement="bottom"
          >
            <el-button type="text" style="width: 35px;">
              <i class="el-icon-question" style="color: #ccc;"></i>
            </el-button>
          </el-tooltip>
          <div style="color:#999999">
            如需中奖后填写地址，建议预留足够的时间给用户填写地址
          </div>
        </el-form-item>
        <div class="newsInfo">曝光商品</div>
        <el-form-item label="曝光商品:" class="zindexBox" required>
          <el-checkbox v-model="ruleForm.exposureSwitch">
            是否添加曝光商品
          </el-checkbox>
          <el-button
            style="width: 155px; margin: 0 15px;display: inline-block;"
            :class="{ add_btn1: ruleForm.exposureSwitch }"
            @click="exposureProducts"
            :disabled="ruleForm.exposureSwitch == false"
          >
            {{
              itemListFor.length != ""
                ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                : "添加曝光商品"
            }}
          </el-button>
          <!-- <el-radio-group
            v-model="ruleForm.radio"
            :disabled="ruleForm.exposureSwitch == false"
          >
            <el-radio :label="0">显示京东价</el-radio>
          </el-radio-group> -->
          <draggable
            v-if="itemListFor.length > 0"
            v-model="mainImagelist"
            chosen-class="chosen"
            :scroll="true"
            animation="150"
            force-fallback="true"
            @start="isDragging = true"
            @end="onEnd"
            style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px;"
          >
            <transition-group type="transition">
              <div
                v-for="(item, index) in mainImagelist"
                :key="item.skuId"
                style="display: inline-block; position: relative"
                class="show_upImg2"
              >
                <img
                  :src="item.logo"
                  width="120px"
                  height="120px"
                  style="display: inline-block"
                />&nbsp;
                <div class="delectPosible">
                  <span class="delectSort">拖动排序</span>
                  <img
                    src="@/assets/thdImg/pages/delet.svg"
                    @click.stop="delec(item, index)"
                    class="delectIcom"
                  />
                </div>
              </div>
            </transition-group>
          </draggable>
        </el-form-item>

        <!-- <el-form-item label-width="10px" style="margin: 0 0 20px 0; text-align: left">
          <el-button class="returnBtn" size="medium" @click="clickLocalStep()"> {{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button>
          <template v-if="!backgroundOpacity">
            <el-button class="keepBtn" type="primary" size="medium" @click="joinBlackList = true" v-preventReClick>保存并完成设置</el-button>
          </template>
        </el-form-item> -->
        <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
      </el-form>
    </div>
    <div class="create_bottom">
      <el-button size="medium" @click="clickLocalStep()">
        {{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <template v-if="!backgroundOpacity">
        <el-button
          class="keepBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存并完成设置</el-button
        >
      </template>
    </div>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      @transferName="selectGoodsClose"
      :postForm="selectGoodsArr"
      :maxNum="20"
    >
    </selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 选择奖品弹窗 -->
    <selectProduct
      ref="selectProductAward"
      :Sans="venderType"
      :echoDate="echoDate"
      :actId="{ id: valueRow }"
      :num="1"
      :JingdouCount="JingdouCount"
      @choose-shop="getTheData"
    >
    </selectProduct>
    <!-- 确定礼包模板弹窗 -->
    <gift-popup
      :activityDataID="30"
      @handleChoice="handleChoice"
      v-if="giftPopup"
    />

    <!-- 选择商品弹窗 -->
    <select-product-single
      v-if="dialogFormVisible"
      :dialogFormVisible="dialogFormVisible"
      @check="chooseShop"
      @close="dialogFormVisible = false"
    >
    </select-product-single>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import selectProduct from "../select_product";
import { mapState } from "vuex";
import {
  freeTrialSave,
  freeTrialCardList,
  editScratchers,
  uploadpic,
} from "@/api/paradiseAndTaskCommonController.js";
import giftPopup from "./giftPopup.vue";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import {
  getTaobaoItemListSku,
  getSellercats,
} from "@/api/analysis/ware-controller.js";
import { getTaobaoItemList, getTaobaoItemSkuList } from "@/api/public1";
import inputForm from "../../../components/inputForm";
import selectProductSingle from "@/components/selectDialog/select-product-single.vue";
export default {
  components: {
    selectProduct,
    giftPopup,
    draggable,
    inputForm,
    selectGoodsMonitor,
    selectProductSingle,
  },
  computed: {
    ...mapState(["venderType"]),
    winningRate() {
      let winningRate = 0;
      this.awardSettingsLsit.forEach((item) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
      });
      return winningRate;
    },
    pickerOptionsValue1() {
      const that = this;
      return {
        disabledDate: (time) => {
          if (that.activityTimeValue[1]) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(
                  this.$store.getters.loginUserInfo.expiredIn
                ).valueOf() ||
              time.getTime() > new Date(that.activityTimeValue[1]).getTime()
            );
          } else {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf()
            );
          }
        },
      };
    },
    pickerOptionsValue2() {
      const that = this;
      return {
        disabledDate: (time) => {
          if (that.activityTimeValue[0]) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(
                  this.$store.getters.loginUserInfo.expiredIn
                ).valueOf() ||
              time.getTime() < new Date(that.activityTimeValue[0]).getTime()
            );
          } else {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf()
            );
          }
        },
      };
    },
    selectCrowdText() {
      return this.crowdList.length === 0
        ? "选择人群"
        : `已选${this.crowdList.length}个`;
    },
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      }
      return result;
    },
    toChinesNum(num) {
      let changeNum = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ]; //changeNum[0] = "零"
      let unit = ["", "十", "百", "千", "万"];
      num = parseInt(num);
      let getWan = (temp) => {
        let strArr = temp
          .toString()
          .split("")
          .reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
          newNum =
            (i == 0 && strArr[i] == 0
              ? ""
              : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
              ? ""
              : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
            newNum;
        }
        if (num >= 10 && num < 20) {
          newNum = newNum.substring(1, 3);
        }
        return newNum;
      };
      let overWan = Math.floor(num / 10000);
      let noWan = num % 10000;
      if (noWan.toString().length < 4) noWan = "0" + noWan;
      return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    },
  },

  data() {
    return {
      rules: {
        //规则判断
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
      },
      crowdList: [],
      isStartEditTime:'',
      isStartEdit:false,
      imageUpload: "",
      imageUpload2: "",
      dialogFormVisible: false,
      formShopList: { current: 1, size: 5, skuStatus: 1 },
      totalListThr: 0,
      tableShopData: [],
      commodityList: [
        {
          name: "商品类目:",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          multiple: true,
          width: 240,
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID",
          isNumber: true,
          width: 240,
        },
        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入商品名称",
          width: 240,
        },
        {
          name: "商品状态:",
          val: "skuStatus",
          default: 1,
          selectArr: [
            { label: "全部", id: null },
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
          width: 136,
        },
      ],
      mainImagelist: [], //图片拖拽排序
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      giftPopup: false,
      stepNum: 0,
      backgroundOpacity: false,
      isSave: true,
      valueRow: null,
      //
      echoDate: {},
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf()
          );
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      selectGoodsStateFilter: false,
      itemListForFilter: [],
      selectGoodsFilterArr: [],
      fromLoading: false, // 数据加载 显示
      loading: false, // 数据加载 显示
      qrcode: null,
      joinBlackList: false,
      checked: false,
      activityStartTime: null,
      activityEndTime: null,
      timeDay: 0,
      timeOut: 0,
      ruleForm: {
        membershipTime:"",
        // 活动对象
        activityObject: 0,
        // 新老客户
        newOldCustomer: 0,
        //设置规则表单
        activityName: "",
        exposureSwitch: false,
        condFollow: 0,
        partner: ["-1"],
        radio: 0,
        ruleDTO: {
          trialType: 1,
          trialRule: 1,
          prizeTime: "",
          productName: "",
        },
        subType: 33,
      },
      awardSettingsLsit: [
        {
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
        },
      ],
      awardIndex: 0,
      timeState1: "",
      staute: 0,
      selectGoodsState: false,
      isDragging: false,
      isCopy: false,
      draggingId: [],
      itemListFor: [],
      mainImagelist: [],
      selectGoodsArr: [],
      levelList: [],
    };
  },
  created() {
    this.getLevel();
    // 数据初始化
    if (this.$route.query.valueRow) {
      this.backgroundOpacity =
        this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.statusComment =
        this.$route.query.statusComment == "true" ? true : false;
      this.valueRow = this.$route.query.valueRow;
      this.isStartEdit = this.$route.query.isStartEdit == "true" ? true : false;
      this.isCopy = this.$route.query.isCopy == "true" ? true : false;
      this.getEdit();
    } else {
      this.activityTimeChange();
    }
    // this.activityTimeChange();
  },
  methods: {
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.partner = ["-1"];
      this.crowdList = [];
    },
    // 活动进行中修改奖品数量
    beAdd(){
      console.log("活动进行中修改奖品数量");
      if(this.isStartEdit){
        if(this.ruleForm.ruleDTO.minNum && Number(this.ruleForm.ruleDTO.trialNum) < Number(this.ruleForm.ruleDTO.minNum)){
          this.ruleForm.ruleDTO.trialNum = this.ruleForm.ruleDTO.minNum
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
        }
      }
    },
    beforeAvatarUpload(file, fileList) {
      // this.$refs.upload.$children[1].$el.style.display = "none";
      // this.objectForm.name = file.name;
      let formdata = new FormData();
      formdata.append("file", file);
      uploadpic(formdata).then((res) => {
        // 获取图片真实url
        this.imageUpload = res.data;
      });
      return false;
    },
    //实物选择
    chooseShop(val) {
      this.imageUpload2 = val.logo;
      // this.objectForm.name = val.skuName.substr(0, 12);
      // this.objectForm.discount = val.jdPrice;
      // this.objectForm.wareId = this.venderType ? val.skuId : val.wareId;
      this.dialogFormVisible = false;
      if (val.skuName.length > 12) {
        this.ruleForm.ruleDTO.productName = val.skuName.substring(0, 12);
      } else {
        this.ruleForm.ruleDTO.productName = val.skuName;
      }
    },
    //分页事件
    handleSizeChangeThr(val) {
      this.formShopList.size = val;
      this.getShopList();
    },
    handleCurrentChangeThr(val) {
      this.formShopList.current = val;
      this.getShopList();
    },
    //获取店铺商品
    getShopList() {
      // this.formShopList;
      getTaobaoItemList(this.formShopList).then((res) => {
        this.tableShopData = res.data.records;
        this.totalListThr = Number(res.data.total);
        // console.log(res, 1111111111);
      });
    },
    searchContent(val) {
      this.formShopList.size = 5;
      this.formShopList.current = 1;
      if (val.categoryId) {
        this.formShopList.categoryId = val.categoryId.join(",");
      } else {
        this.formShopList.categoryId = "";
      }
      this.formShopList.skuId = val.skuId;
      this.formShopList.skuStatus = val.skuStatus;
      this.formShopList.skuName = val.skuName;
      this.getShopList();
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    selectGoodsClose(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }
      this.selectGoodsState = false;
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      // this.$refs.selectGo.handleRightCurrentChange(1);
      // this.$refs.selectGo.handleRightCurrentChange(1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      console.log("this.mainImagelist)", this.mainImagelist);
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
      console.log("this.mainImagelist)", arr);
    },
    //删除
    delec(item, index) {
      // this.mainImagelist.splice(index, 1);
      // this.itemListFor.splice(index, 1);
      
      let i = -1;
      this.mainImagelist.forEach((items, index1) => {
        if (items.skuId == item.skuId) i = index1;
      });
      console.log(i, 55555);
      if (i != -1) {
        this.mainImagelist.splice(i, 1);
        this.itemListFor = this.mainImagelist;
      }
    },
    async getEdit() {
      const { data } = await freeTrialCardList(this.valueRow);
      let itemList = data.itemList;
      if (itemList) {
        itemList = itemList.map((item) => {
          return {
            ...item,
            picUrl: item.logo,
          };
        });
      }
      this.staute = data.status || 0;
      this.timeState1 = data.startTime;
      this.ruleForm.partner = data.allowLevel.split(",");
      this.ruleForm.membershipTime = data.membershipTime
      this.activityTimeValue = [String(data.startTime), String(data.endTime)];
      if(this.isStartEdit){
        //进行中活动 无法修改活动开启时间
        this.isStartEditTime = String(data.startTime)
      }
      this.ruleForm.activityName = data.activityName;
      this.ruleForm.activityStartTime = String(data.startTime);
      this.ruleForm.activityEndTime = String(data.endTime);
      this.ruleForm.activityObject = data.hasOwnProperty("activityObject")
          ? data.activityObject
          : 0;
        this.ruleForm.newOldCustomer = data.hasOwnProperty("newOldCustomer")
          ? Number(data.newOldCustomer)
          : 0;
        this.crowdList = data.hasOwnProperty("seniorGroupId") && data.seniorGroupId
          ? data.seniorGroupId.split(",")
          : [];
      this.ruleForm.ruleDTO = data.freeTrialActivityRuleDTO;
      this.ruleForm.ruleDTO.minNum = this.ruleForm.ruleDTO.trialNum;
      if(this.ruleForm.ruleDTO.isOpenCard==1) {
        if(!this.ruleForm.partner.includes('0')) {
          this.ruleForm.partner.push("0");
        }
      }
      this.ruleForm.condFollow = data.condFollow;
      this.itemListFor = itemList;
      this.mainImagelist = itemList;
      this.selectGoodsArr = itemList;
      this.ruleForm.radio = data.priceType;
      this.ruleForm.exposureSwitch = data.isExposureItem ? true : false;
      this.ruleForm.id = this.valueRow;
      if (data.freeTrialActivityRuleDTO.trialType == 1) {
        this.imageUpload = data.freeTrialActivityRuleDTO.picUrl;
      } else {
        this.imageUpload2 = data.freeTrialActivityRuleDTO.picUrl;
      }
      this.activityTimeChange();
    },
    handleChoice(val) {
      console.log(val);
      if (val) {
        this.ruleForm.gameTemplateId = val.id;
        this.ruleForm.winImageUrl = val.imageUrl;
        this.ruleForm.noWinImageUrl = val.secondImageUrl;
        this.ruleForm.thankImageUrl = val.thankImageUrl;
      }
      this.giftPopup = false;
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 117, // 设置宽度，单位像素
        height: 117, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //活动时间驱动
    activityTimeChange(val) {
      if(this.isStartEdit){
        //进行中活动 无法修改活动开启时间
        this.activityTimeValue[0]= this.isStartEditTime
      }
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let CRMtime = new Date(this.orderCRMtime).valueOf();
      let invalidateDate = new Date(
        this.$store.getters.loginUserInfo.expiredIn
      ).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart =
        this.ruleForm.activityStartTime &&
        this.ruleForm.activityStartTime.substring(0, 10);
      daysEnd =
        this.ruleForm.activityEndTime &&
        this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime && this.ruleForm.activityStartTime) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        // if (days > 90) {
        //   this.$message.warning("活动时间不得超过90天！");
        //   this.ruleForm.activityEndTime = null;
        //   this.timeOut = 0;
        //   this.timeDay = 0;
        //   return;
        // }

        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      if ((start - nowTime) / 1000 / 60 < 5) {
        if (this.valueRow) {
          this.disableTime = true;
        } else {
          // console.log(this.activityTimeValue);
          // this.$message.warning("活动时间开始时间要大于当前时间的5分钟");
          // this.activityTimeValue[0] = "";
          // this.ruleForm.activityStartTime = null;
          // return;
        }
      }
      if (end < nowTime && end) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (end < start && start && end) {
        this.$message.warning("结束时间不能小于开始时间");

        return;
      }
    },
    deletePacket(index) {
      this.awardSettingsLsit.splice(index, 1);
    },
    // 获取奖品
    getTheData(data, prizeType) {
      console.log(data, 666);
      if (prizeType == 1) {
        this.awardSettingsLsit[this.awardIndex].couponType = data.couponType;
        this.awardSettingsLsit[this.awardIndex].singleAmount = 1;
        this.awardSettingsLsit[this.awardIndex].quota = data.quota;
      }
      if (prizeType == 2) {
        this.awardSettingsLsit[this.awardIndex].quantityTotal =
          data.quantityTotal;
      }
      if (data.giftType) {
        this.awardSettingsLsit[this.awardIndex].giftType = Number(
          data.giftType
        );
      }
      this.awardSettingsLsit[this.awardIndex].price =
        data.discount || data.singleAmount;

      this.awardSettingsLsit[this.awardIndex].assetsId = Number(data.couponId);
      this.awardSettingsLsit[this.awardIndex].logo = data.logo;
      this.awardSettingsLsit[this.awardIndex].prizeType = prizeType;
      if (prizeType == 4) {
        this.awardSettingsLsit[this.awardIndex].title =
          data.discount + "店铺积分";
      } else {
        this.awardSettingsLsit[this.awardIndex].title =
          data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
      }
      if (data.singleAmount) {
        this.awardSettingsLsit[this.awardIndex].singleAmount =
          data.singleAmount;
      }
      console.log(this.awardSettingsLsit, 123);
    },
    addPacket() {
      this.awardSettingsLsit.push({
        prizeType: null,
        price: null,
        title: "",
        totalAmount: null,
        percentage: null,
      });
    },
    // 红包雨
    selectPacket(index, item) {
      this.$refs.selectProductAward.openDialog();
      this.JingdouCount.prizeCount = item.totalAmount;
      this.awardIndex = index;
      this.echoDate = item;
      this.$refs.selectProductAward.physicalGift(item)
    },
    // 保留小数点后两位
    oninput2(obj) {
      obj = obj.replace(/[^\d.]/g, ""); //清除除了“数字”和“.”以外的字符
      obj = obj.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      obj = obj
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      obj = obj.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3"); //只能输入3个小数
      if (obj > 100) {
        obj = 100;
      }

      let value = obj * 1;
      let winningRate = 0;
      this.awardSettingsLsit.forEach((item) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
      });

      if (winningRate > 100) {
        obj = 100 - (winningRate - value);
      } else if (winningRate == 100) {
        if (value >= 100) {
          obj = 100;
        } else {
          obj = 100 - (winningRate - value);
          if (value == 0) {
            obj = 0;
          }
        }
      }
      return obj;
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        row.prizeCount = row.totalAmount;
        if (
          row.quantityTotal &&
          row.price &&
          row.totalAmount &&
          row.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal(row);
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    //保存编辑
    saveEdit(){
      if(this.ruleForm.activityEndTime && this.ruleForm.ruleDTO.prizeTime){
        let time1 = new Date(this.ruleForm.activityEndTime).getTime();
        let time2 = new Date(this.ruleForm.ruleDTO.prizeTime).getTime();
        let timeDiff = Math.abs(time2 - time1);
        let hoursDiff = timeDiff / (1000 * 60 * 60);
        if (hoursDiff < 48 || time1 - time2 < 0) {
          // console.log('两个时间相差48小时以内');
          this.$message.warning("开奖时间要在活动结束时间之前至少48小时！");
          return;
        } else {
          // console.log('两个时间相差超过48小时');
        }
      }
      if (this.ruleForm.activityObject == 2 && !this.crowdList.length) {
        return this.$message.error("请完善活动对象信息！");
      }

      this.joinBlackList = true
    },
    // 抽奖判断
    orderChange() {
      if (
        Number(this.ruleForm.oneDayMaxDrawNumber) >
          Number(this.ruleForm.totalMaxDrawNumber) &&
        this.ruleForm.totalMaxDrawNumber &&
        this.ruleForm.oneDayMaxDrawNumber
      ) {
        this.ruleForm.totalMaxDrawNumber = "";
        this.$message.warning("活动期间每人每天抽奖次数不能大于累计抽奖次数");
      }
      if (
        Number(this.ruleForm.oneDayMaxRewardNumber) >
          Number(this.ruleForm.totalMaxRewardNumber) &&
        this.ruleForm.oneDayMaxRewardNumber &&
        this.ruleForm.totalMaxRewardNumber
      ) {
        this.ruleForm.totalMaxRewardNumber = "";
        this.$message.warning("活动期间每人每天中奖次数不能大于累计中奖次数");
      }
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      try {
        this.ruleForm.activityStartTime =
          this.activityTimeValue.length == 0 ? "" : this.activityTimeValue[0];
        this.ruleForm.activityEndTime =
          this.activityTimeValue.length == 0 ? "" : this.activityTimeValue[1];
      } catch (err) {
        this.$message.warning("请输入活动时间");
        return;
      }

      let cardParams = {
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        gameTemplateId: this.ruleForm.gameTemplateId,
        activityObject: this.ruleForm.activityObject,
        newOldCustomer: this.ruleForm.newOldCustomer,
        ruleDTO: {
          oneDayMaxDrawNumber: this.ruleForm.oneDayMaxDrawNumber,
          totalMaxDrawNumber: this.ruleForm.totalMaxDrawNumber,
          oneDayMaxRewardNumber: this.ruleForm.oneDayMaxRewardNumber,
          totalMaxRewardNumber: this.ruleForm.totalMaxRewardNumber,
          extraUrl: this.ruleForm.extraUrl,
          noWinImageUrl: this.ruleForm.noWinImageUrl,
          winImageUrl: this.ruleForm.winImageUrl,
          thankImageUrl: this.ruleForm.thankImageUrl,
        }, //活动名称
        integralParadisePrizeDTOS: [], // 奖品
      };
      let isflay = false;
      cardParams.integralParadisePrizeDTOS = this.awardSettingsLsit.map(
        (item) => {
          let prize = {
            ...item,
            title: item.title,
            assetsId: item.assetsId,
            prizeType: item.prizeType,
            singleAmount: item.singleAmount, //
            totalAmount: item.totalAmount, // 总数额
            price: item.price,
            percentage: item.percentage ? item.percentage * 1 : 0,
          };
          if (prize.prizeType == 3) {
            prize.logo = item.logo;
          }
          if (prize.prizeType == 1) {
            prize.quota = item.quota;
            prize.couponType = item.couponType;
          }
          if (prize.prizeType == 2 || prize.prizeType == 4) {
            prize.singleAmount = item.price;
          } else {
            prize.singleAmount = 1;
          }
          if (!item.singleAmount) isflay = true;
          return prize;
        }
      );

      //活动名称的限制
      if (
        !this.ruleForm.activityName ||
        this.ruleForm.activityName.length == 0
      ) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      let obj = JSON.parse(JSON.stringify(this.ruleForm));
      if (obj.ruleDTO.trialType == 1) {
        obj.ruleDTO.picUrl = this.imageUpload;
      } else {
        obj.ruleDTO.picUrl = this.imageUpload2;
      }
      if (!obj.ruleDTO.picUrl) {
        this.$message.warning("请选择图片");
        return;
      }
      obj.allowLevel = obj.partner.join(",");
      obj.endTime = obj.activityEndTime;
      obj.startTime = obj.activityStartTime;
      obj.isExposureItem = obj.exposureSwitch ? 1 : 0;
      obj.priceType = obj.radio;
      obj.itemList = this.itemListFor;
      obj.seniorGroupId = this.crowdList.join(",");
      obj.freeTrialActivityRuleDTO = JSON.parse(JSON.stringify(obj.ruleDTO));
      obj.freeTrialActivityRuleDTO.productName =
        obj.freeTrialActivityRuleDTO.productName || null;
      delete obj.partner;
      delete obj.activityStartTime;
      delete obj.activityEndTime;
      delete obj.radio;
      delete obj.exposureSwitch;

      //判断勾选提示后即可调取接口
      if (this.checked == true) {
        delete obj.ruleDTO;
        console.log("保存", obj, this.ruleForm);
        if (this.isCopy) {
          delete obj.id
        }
        freeTrialSave(obj).then((res) => {
          if (res.code == 1) {
            this.joinBlackList = false;
            this.clickLocalStep();
          } else {
            this.$message.warning(res.message);
          }
        });
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    clickLocalStep() {
      this.$router.go(-1);
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
  },
};
</script>

<style lang="scss" scoped>
.check-dialog ::v-deep .formSearch {
  min-width: auto;
}

.ylt {
  width: 235px;
  height: 430px;
  position: absolute;
  left: 720px;
  top: 0;
  background: url("../../../assets/thdImg/active/0yuansy.png") no-repeat;
  background-size: 235px 430px !important;
  img {
    width: 90px;
    height: 90px;
    position: absolute;
    left: 15px;
    top: 120px;
    border-radius: 6px;
  }
  .yltText1 {
    position: absolute;
    top: 116px;
    left: 112px;
    font-weight: bold;
    font-size: 12px;
    color: #121212;
  }
  .yltText2 {
    position: absolute;
    top: 134px;
    left: 112px;
    font-weight: 400;
    font-size: 9px;
    color: #CD9558;
  }
}
.smart {
  display: flex;
  margin-top: 24px;
  width: 100%;
  &_left {
    width: 235px;
    height: 430px;
    background: url("../../../assets/images/cardManage/scratch_yulan.png")
      no-repeat;
    background-size: 235px 430px;
    margin-right: 30px;
    display: flex;
    justify-content: center;
  }
  &_content {
    width: 93%;
    // background: #2670FB;
    height: 90px;
    margin-top: 194px;
    img {
      width: 100%;
      height: inherit;
    }
  }
  &_right {
    width: 235px;
    height: 430px;
    background-size: 235px 430px;
    background: url("../../../assets/images/cardManage/scratch_yulan.png")
      no-repeat;
    display: flex;
    justify-content: center;
    // &_img {
    //   height: 430px;
    //   background: #999;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    // }
  }
}
.smart_right_tip {
  width: 230px;
  color: #999;
  margin-top: 5px;
  font-size: 12px;
  text-align: center;
  position: absolute;
  bottom: -30px;
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #cccccc;
  display: inline-block;
  line-height: 12px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #cccccc;
  font-size: 12px;
  font-weight: normal;
  margin-left: 6px;
  &:hover {
    border: 1px solid #2670fb;
    color: #2670fb;
  }
}
.card-point {
  width: 100%;
  background: #fafafa;
  border-radius: 4px;
  margin-top: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    // margin-left: 12px;
    padding-left: 18px;
    // width: 60px;
    background: url("../../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
    line-height: 1;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}
.btn1 {
  cursor: pointer;
  color: #2670fb;
  border: 1px solid #2670fb;
  background: rgba(38, 112, 251, 0.1);
  &:hover {
    background: #2670fb;
    color: #fff;
  }
}

.add_btn1 {
  cursor: pointer;
  color: #2670fb;
  border: 1px solid #2670fb;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(38, 112, 251, 0.1);
  border-radius: 4px;
  margin-top: 8px;
  &:hover {
    background: #2670fb;
    color: #fff;
  }
}
.memberTips {
  color: red;
}
/deep/ .el-upload--picture-card {
  width: 120px;
  height: 120px;
}
.dataPicker {
  /deep/.el-button--text {
    display: none !important;
  }
}

/deep/ .el-table__body-wrapper {
  // overflow: visible !important;
}
/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}

.ruloBox {
  width: 860px;
  height: 69px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
}

.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.rule_box {
  width: 860px;
  // height: 217px;
  background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 15px 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
  }
  &_bottom {
    margin-left: 7px;
  }
}

.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}
.startTime {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #2670fb;
  }
  color: #999;
}
.delectPosible {
  position: absolute;
  top: -3px;
  right: 6px;
  color: red;
  cursor: pointer;
}
.delectPosible:hover {
  -webkit-box-shadow: #ccc 0px 1px 1px;
  -moz-box-shadow: #ccc 0px 1px 1px;
  box-shadow: #ccc 0px 1px 1px;
}
.flex {
  display: flex;
  align-items: center;
}

.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin-top: 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
      margin-left: 11%;
    }
  }

  .secondstep {
    // min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 24px 28px 1px 24px;
    // margin-bottom: 29px;
    height: calc(100vh - 225px);
    overflow-y: auto;

    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;
      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url("../../../assets/images/integralCenter/yhq.png");
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .discount_sty {
          font-family: DIN;
          font-weight: bold;
          color: #2670fb;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 280px;
          height: 120px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #2670fb;
      color: #2670fb;
      transition: all 0.2s;
      &:hover {
        background-color: #2670fb;
        color: #fff;
      }
    }
  }
}
.qyBox:last-child .qyLeft,
.qyBox:last-child .qyRight {
  border-bottom: 1px solid #eeeeee;
}
.qyLeft {
  width: 150px;
  border-top: 1px solid #eeeeee;
  border-left: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  padding-left: 10px;
  height: 52px;
  line-height: 52px;
}
.qyRight {
  width: 200px;
  border-top: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  padding-left: 10px;
  height: 52px;
  line-height: 52px;
}

::v-deep .keepBtn {
  margin-left: 30px;
  width: 188px;
  background-color: #2670fb;
  color: #fff;
  transition: all 0.2s;
  &:hover {
    opacity: 0.9;
  }
}
</style>

<style lang="scss">
.createPlayStep {
  .el-step.is-horizontal .el-step__line {
    height: 1px;
  }
  .el-step__head.is-success {
    color: #2670fb;
    border-color: #2670fb;
    .el-step__line {
      background-color: #2670fb;
    }
  }
  .el-step__head.is-process {
    color: #2670fb;
    border-color: #2670fb;
  }
  .el-step__title.is-process {
    color: #2670fb;
  }
  .el-step__title.is-success {
    color: #2670fb;
  }
  // .textarea {
  //   .el-textarea__inner {
  //     min-height: 80px !important;
  //   }
  // }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.tooplitMax {
  max-width: 1000px !important;
}
.margin-left-8 {
  margin-left: 8px;
}
.margin-left-12 {
  margin-left: 12px;
  i {
    cursor: pointer;
    color: #ccc;
  }
}
.tips-style {
  color: #cccccc;
}
</style>
